import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Button, Modal, Table, Icon, Pagination } from "../../components";
import { CashCount as CC } from "../../services";
import AddIcon from '../../assets/icons/add.png';
import PrinterIcon from '../../assets/icons/printer.png';

// Components
import Menu from "../menu";
import Filter from "./filterForm";
import ManageCashCount from "./manage-cash-count";
import { axios, ENV, Globals } from "../../utils";

const TABLE_HEADER = [
  "N° de Cierre",
  "Fecha y hora\nde cierre",
  "Ingresos\nTotales ($)",
  "Egresos\nTotales ($)",
  "Ingresos\nTotales (Bs.)",
  "Egresos\nTotales (Bs.)",
  "Saldo Total\nCuadre ($)",
  "Acciones"
];

class CashCount extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        user_id: this.props.user.id,
        search: "",
        since: "",
        until: "",
      },
      cashCountModalTitle: 'Cierre de caja',
      visible: false,
      visibleCashCount: false,
      visibleResume: false,
      itemDetails: null,
      data: [],
      cashRegisters: [],
    };
  }

  componentDidMount() {
    this.load();
  }

  load = async (page = 1) => {
    try {
      const res = await CC.getCashClossings(this.state.form);
      this.setState({
        page,
        last_page: res.data.last_page,
        data: res.data.data,
      });

    } catch (error) {
      console.log(error);
    }
  };

  cashCount = async () => {
    await this.setState({ visible: false, visibleCashCount: true });
  };

  deployManage = Item => {
    this.setState({ Item: Item, visible: true });
  };

  processingPayment = (newPayment) => {

    const { Item, data } = this.state;
    const key = data.findIndex(({ id }) => id === Item.id);
    const newData = [...data];

    newData[key] = {
      ...newData[key],
      amount_available: newData[key].amount_available + parseFloat(newPayment.amount)
    };

    newPayment.amount = parseFloat(newPayment.amount);
    newPayment.current_amount = parseFloat(newPayment.current_amount);
    newPayment.type = parseInt(newPayment.type);
    newPayment.status = 0;

    this.setState(state => ({
      visibleCreate: false,
      visibleProcessing: true,
      Item: {
        ...state.Item,
        amount_available: newData[key].amount_available,
        payments: [...state.Item.payments, newPayment]
      },
      data: newData
    }));
  };

  close = async (success = false) => {
    await this.viewResume(false);
    await this.setState({ visible: false, visibleCashCount: false, itemDetails: null });
    if (success) this.load();
  };

  viewResume = async (view) => {
    const title = view ? 'Resumen de cierre de caja' : 'Cierre de caja';
    await this.setState({ visibleResume: view, cashCountModalTitle: title });
  }

  viewDetails = async (item) => {
    await this.setState({ itemDetails: item });
    this.viewResume(true);
    this.cashCount();
  }

  print = async () => {
    try {
      const res = await CC.getCashClossings({ ...this.state.form, download: true })
      if (res.url_storage) {
        //const url = res.data.url;
        const url = `${ENV.BasePublic}${res.url_storage}`;
        const win = window.open(url, "_blank");
        win.focus();
      }
      else {
        Globals.showError('Ha ocurrido un error');
      }

    } catch (error) {
      console.log(error);
      Globals.showError('Ha ocurrido un error');
    }
  }

  printDetails = async (item) => {
    axios
      .post(`admin/cash-count/${item.id}/download`, this.state.form)
      .then(res => {
        if (res.data.url_storage) {
          //const url = res.data.url;
          const url = `${ENV.BasePublic}${res.data.url_storage}`;
          const win = window.open(url, "_blank");
          win.focus();
        }
        else {
          Globals.showError('Ha ocurrido un error');
        }
      })
      .catch(err => {
        Globals.showError();
      });
  }

  render() {
    const { data, visibleResume, visibleCashCount, cashCountModalTitle, itemDetails } = this.state;
    const { user, history } = this.props;

    return (
      <Menu history={history}>
        {visibleCashCount && (
          <Modal
            className="modal-cash-count"
            title={cashCountModalTitle}
            onClose={this.close}
            visible
          >
            <ManageCashCount
              onClose={this.close}
              viewResume={this.viewResume}
              visibleResume={visibleResume}
              readonly={!!itemDetails}
              item={itemDetails}
            />
          </Modal>
        )}

        <div id="cash-count">
          <div className="container-fluid">
            <Filter
              submitted={async (form) => {
                await this.setState(s => ({ form: { ...s.form, ...form } }));
                this.load();
              }}
              user={user}
            />

            <div className="row">
              <div className="col-md">
                <Table
                  data={data.length}
                  title="Cierre de Caja"
                  header={TABLE_HEADER}
                  right={
                    <>
                      <Button
                        small="true"
                        title="Imprimir"
                        onClick={() => this.print()}
                      >
                        <img src={PrinterIcon} alt="Imprimir" />
                      </Button>
                      <Button
                        small="true"
                        title="Agregar cierre de caja"
                        onClick={() => this.cashCount()}
                      >
                        <img src={AddIcon} alt="Agregar cierre de caja" />
                      </Button>
                    </>
                  }
                >
                  {data.length > 0 && data.map((Item, index) => {
                    return (
                      <tr key={index}>
                        <td>{Item?.code}</td>
                        <td>{moment(Item?.created_at).format('DD/MM/YYYY; h:mm a')}</td>
                        <td align="right">{Globals.formatMiles(Item?.entry_amount)}</td>
                        <td align="right">{Globals.formatMiles(Item?.out_amount)}</td>
                        <td align="right">{Globals.formatMiles(Item?.entry_amount_bs)}</td>
                        <td align="right">{Globals.formatMiles(Item?.out_amount_bs)}</td>
                        <td align="right">{Globals.formatMiles(Item?.current_amount)}</td>
                        <td>
                          <Button
                            color=" "
                            title="Ver más"
                            small="true"
                            onClick={() => this.viewDetails(Item)}
                          >
                            <Icon name="eye" />
                          </Button>
                          <Button
                            color=" "
                            title="Imprimir"
                            small="true"
                            onClick={() => this.printDetails(Item)}
                          >
                            <Icon name="download" />
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </Table>
              </div>
            </div>
          </div>
        </div>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={page => this.load(page)}
        />
      </Menu>
    );
  }
}

export default connect(state => {
  return {
    user: state.user
  };
})(CashCount);
